module.exports = __webpack_public_path__ + "static/media/chandler.9d90f72e.jpg";